import React, { useEffect, useState } from "react";

import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { OnboardingStage } from "../../../models/onboarding.stage";
import { UploadValueType } from "../../../util/enums";
import env from "../../../util/env";
import Button, { Color } from "../../Form/Button";
import { UploadFile } from "../UploadCenter/UploadFile";
import useStyles from "./styles";

interface Props {
  uploadType?: UploadValueType;
  setUploadType: (uploadType: UploadValueType) => void;
  onboardingStage?: OnboardingStage;
  onUpdateOnboardingStage: (OnboardingStage: OnboardingStage) => void;
}

const UploadCentreShipmentTracking = (props: Props) => {
  const { onboardingStage, uploadType, setUploadType, onUpdateOnboardingStage } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [useShipmentDetails, setUseShipmentDetails] = useState<string>("false");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUseShipmentDetails(event.target.value);
  };

  useEffect(() => {
    if (onboardingStage && !uploadType && onboardingStage.shipmentWasUploaded) {
      setUploadType(UploadValueType.UPLOAD_VALUE_OWN_LIST);
    }
  }, [onboardingStage]);

  return (
    <main data-cy="uploadCentre" className={classes.container}>
      <h1 data-cy="uploadCentreTitle" className={classes.title}>
        {translate("uploadCentre")}
      </h1>

      <p className={classnames(classes.description, classes.mb0)}>
        {translate(
          "youCanGetStartedTrackingShipmentsFromHereRegardlessOfHowManyForwardersOrRoutes"
        )}
      </p>
      <p className={classnames(classes.description, classes.mb12)}>
        {translate("eitherUploadACsvFileUsingTheTemplateOrClickNextToEnterAContainerNumber")}
      </p>

      <FormControl>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={useShipmentDetails}
          onChange={handleChange}
        >
          <FormControlLabel
            value="true"
            className={classes.radioLabel}
            control={<Radio className={classes.radioButton} />}
            label={translate("uploadYourShipmentDetails")}
          />
        </RadioGroup>
      </FormControl>
      {useShipmentDetails === "true" && (
        <section className={classes.buttonsSection}>
          <UploadFile
            uploadType={uploadType ?? UploadValueType.UPLOAD_VALUE_OWN_LIST}
            onboardingStage={onboardingStage}
            onUpdateOnboardingStage={onUpdateOnboardingStage}
          />
          {!onboardingStage?.shipmentWasUploaded && (
            <a href={env.LINK_SHIPMENT_TRACKING_TEMPLATE_ZIP} download>
              <Button customColor={Color.INFO}>{translate("downloadOurCsvTemplateHere")}</Button>
            </a>
          )}
        </section>
      )}
    </main>
  );
};

export default UploadCentreShipmentTracking;
